import { Popover, Tag, Tooltip } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { DATAHUB_SYSTEM, CORP_USER, CORP_GROUP } from '../../../../ingest/source/utils';
import { CorpGroup, CorpUser, EntityType } from '../../../../../types.generated';
import { useTranslation } from '../../../../../i18n/useTranslation';
import { useEntityRegistry } from '../../../../useEntityRegistry';
import { CustomAvatar } from '../../../../shared/avatar';

type Props = {
    actor: CorpUser | CorpGroup;
    popOver?: React.ReactNode;
    closable?: boolean | undefined;
    onClose?: () => void;
};

const ActorTag = styled(Tag)`
    padding: 2px;
    max-height: 24px;
    padding-right: 6px;
    margin-bottom: 8px;
    align-items: center;
    display: inline-flex;
    color: #4c4e54 !important;
    border-radius: 16px !important;
    background-color: #f8f8f9 !important;
`;

export const ExpandedActor = ({ actor, popOver, closable, onClose }: Props) => {
    const { t } = useTranslation();
    const entityRegistry = useEntityRegistry();
    let name = '';
    let path = `${entityRegistry.getEntityUrl(actor.type, actor.urn)}`;

    if (actor.__typename === CORP_GROUP) {
        name = entityRegistry.getDisplayName(EntityType.CorpGroup, actor);
    }
    if (actor.__typename === CORP_USER) {
        name = entityRegistry.getDisplayName(EntityType.CorpUser, actor);
    }

    if (name === DATAHUB_SYSTEM) {
        name = t('System');
        path = '#';
    }

    const pictureLink = (actor.__typename === CORP_USER && actor.editableProperties?.pictureLink) || undefined;
    const username = actor.__typename === CORP_USER ? actor.username : undefined;
    const isSystemUser = username === DATAHUB_SYSTEM;

    const tooltipContent = (
        <div>
            <div>{name}</div>
            {/* If the email is not the same as the name, and it's not the system user, show the username */}
            {username !== name && !isSystemUser && <div>{username}</div>}
        </div>
    );

    return (
        <Tooltip title={tooltipContent}>
            <ActorTag onClose={onClose} closable={closable}>
                <Link className="truncate" title={name} to={path}>
                    <CustomAvatar
                        size={16}
                        name={name}
                        hideTooltip
                        email={username}
                        photoUrl={pictureLink}
                        useDefaultAvatar={false}
                        style={{ marginRight: 4 }}
                    />
                    {(!popOver && <>{name}</>) || (
                        <Popover overlayStyle={{ maxWidth: 200 }} placement="left" content={popOver}>
                            {name}
                        </Popover>
                    )}
                </Link>
            </ActorTag>
        </Tooltip>
    );
};
